import { Typography } from '@/components';
import { TextStyles } from '@/constants';
import Image from 'next/image';
import styled from 'styled-components';

const DESKTOP_DIALOG_WIDTH = 480;
const MOBILE_DIALOG_WIDTH = 335;

export const DialogWrapper = styled.div(({ theme }) => ({
  borderRadius: theme.spacing[8],
  overflow: 'hidden',
  width: DESKTOP_DIALOG_WIDTH,
  [`${theme.mediaBreakpointDown.md}`]: {
    width: MOBILE_DIALOG_WIDTH,
  },
}));

export const DialogHeaderWrapper = styled.div(({ theme }) => ({
  background: theme.colors.darkBlue,
  position: 'relative',
  height: 40,
  padding: theme.spacing[8],
}));

export const DialogHeaderContentWrapper = styled.div({
  position: 'relative',
  zIndex: 1,
});

export const DialogContentWrapper = styled.div(({ theme }) => ({
  padding: 40,
  textAlign: 'center',
  backgroundColor: theme.colors.highEmphasisWhite,
  [`${theme.mediaBreakpointDown.md}`]: {
    padding: '40px 20px',
  },
}));

export const DialogMainText = styled(Typography).attrs({ variant: TextStyles['Heading 2'] })(({ theme }) => ({
  marginBottom: 4,
  color: theme.colors.highEmphasisBlack,
}));

export const DialogSubText = styled(Typography).attrs({ variant: TextStyles['Body Text Large'] })(({ theme }) => ({
  color: theme.colors.mediumEmphasisBlack,
}));

const CLOSE_ICON_SIZE = 24;

export const DialogExit = styled.button(({ theme }) => ({
  position: 'absolute',
  right: theme.spacing[8],
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'transparent',
  border: 'none',
  width: CLOSE_ICON_SIZE,
  height: CLOSE_ICON_SIZE,
}));

export const CloseIcon = styled(Image).attrs({
  alt: 'Close Dialog',
  src: '/images/icons/close_icon.svg',
  width: CLOSE_ICON_SIZE,
  height: CLOSE_ICON_SIZE,
})({});
